module.exports = __webpack_public_path__ + "img/filters-arrow-icon.5e20ca83.svg";